(() => {
  if (window.eaunexaPromoCopyBound) return;
  window.eaunexaPromoCopyBound = true;

  const copyCode = async (code) => {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(code);
      return;
    }

    const input = document.createElement('textarea');
    input.value = code;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-eaunexa-copy-code]');
    if (!button) return;

    const code = button.dataset.eaunexaCopyCode;
    const status = button.parentElement.querySelector('[data-eaunexa-copy-status]');
    const originalLabel = button.textContent;

    try {
      await copyCode(code);
      button.textContent = 'Code copié';
      if (status) status.textContent = `Le code ${code} a été copié.`;
    } catch (error) {
      button.textContent = code;
      if (status) status.textContent = `Copiez manuellement le code ${code}.`;
    }

    window.setTimeout(() => {
      button.textContent = originalLabel;
    }, 2200);
  });
})();
